import { t } from 'i18next';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useUpdateUserProfileImage } from '../../../graphql/apis/user/mutations/hooks/useUpdateUserProfileImage';
import { RootState } from '../../../redux/store';
import { ImageTypeEnum, uploadImageToTempStorage } from '../../../rest';
import { colors } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import ProfileImageManagement from '../ProfileImageManagement';

const AccountSettingsProfileImageField = () => {
  const currentUser = useSelector((state: RootState) => state.user);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { updateUserProfileImage, loading } = useUpdateUserProfileImage({
    onCompleted: (data) => {
      if (data.updateUserProfileImage.success) {
        setSuccessMessage(t('accountSettings.profileImageUpdateSuccess'));
        setErrorMessage(null);
      } else if (data.updateUserProfileImage.errorMessageStatus) {
        setErrorMessage(
          t(`errors.${data.updateUserProfileImage.errorMessageStatus}`),
        );
        setSuccessMessage(null);
      }
    },
    onError: () => {
      setErrorMessage(t('common.errorOccured'));
      setSuccessMessage(null);
    },
  });

  const handleImageChange = async (file: File) => {
    setSuccessMessage(null);
    setErrorMessage(null);

    try {
      const uploadedUrl = await uploadImageToTempStorage(
        file,
        ImageTypeEnum.PROFILE,
      );
      await updateUserProfileImage({
        variables: {
          profileImage: uploadedUrl,
        },
      });
    } catch (error) {
      console.error('Error updating profile image:', error);
      setErrorMessage(t('common.errorOccured'));
    }
  };

  return (
    <div>
      {successMessage && (
        <div
          style={{
            color: colors.green,
            fontSize: fontSize.sm,
            marginBottom: spacing.small,
          }}
        >
          {successMessage}
        </div>
      )}
      {errorMessage && (
        <div
          style={{
            color: colors.red,
            fontSize: fontSize.sm,
            marginBottom: spacing.small,
          }}
        >
          {errorMessage}
        </div>
      )}
      <div
        style={{
          marginTop: spacing.small,
        }}
      >
        <ProfileImageManagement
          currentImageUrl={currentUser?.profileImage}
          username={currentUser?.username}
          onImageChange={handleImageChange}
          size={100}
        />
      </div>
    </div>
  );
};

export default AccountSettingsProfileImageField;
